import * as tslib_1 from "tslib";
import { BaseComponent } from "../base/base.component";
import { AppComponent } from "../app.component";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HeaderUtils } from "../../crossconcern/utilities/utils/header.utils";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../crossconcern/utilities/properties/base.property";
import { AlertUtils } from "../../crossconcern/utilities/utils/alert.utils";
var BackOfficeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BackOfficeComponent, _super);
    function BackOfficeComponent(appComponent, router, location, headerUtils, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.headerUtils = headerUtils;
        _this.alertUtils = alertUtils;
        _this.isSidebarOpen = true;
        _this.sidebarMode = "push";
        _this.headerButtons = [];
        return _this;
    }
    BackOfficeComponent.prototype.ngOnInit = function () {
        if (window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.sidebarMode = "push";
            this.isSidebarOpen = true;
        }
        else {
            this.sidebarMode = "over";
            this.isSidebarOpen = false;
        }
        this.handleHeader(this.router.url);
        this.handleMapActionsPosition();
        this.subscribeOnRouteChange();
    };
    BackOfficeComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.sidebarMode = "push";
            this.isSidebarOpen = true;
        }
        else {
            this.sidebarMode = "over";
        }
        this.handleMapActionsPosition();
        this.refreshSidebar();
    };
    // Sidebar component
    BackOfficeComponent.prototype.onItemClick = function (item) {
        this.goToRoute(item.url);
    };
    BackOfficeComponent.prototype.toggleSidebar = function () {
        this.isSidebarOpen = !this.isSidebarOpen;
        this.handleMapActionsPosition();
    };
    BackOfficeComponent.prototype.refreshSidebar = function () {
        var _this = this;
        setTimeout(function () {
            _this.sidebarElement.triggerRerender();
        }, 900);
    };
    BackOfficeComponent.prototype.subscribeOnRouteChange = function () {
        var _this = this;
        this.router.events.subscribe(function (val) {
            if (val instanceof NavigationEnd) {
                _this.handleHeader(_this.router.url);
            }
        });
    };
    // manage the header elements
    BackOfficeComponent.prototype.handleHeader = function (path) {
        this.headerButtons = this.headerUtils.getElements(path);
    };
    BackOfficeComponent.prototype.handleMapActionsPosition = function () {
        var mapActionsSections = document.getElementById("map-actions-section");
        if (mapActionsSections != null) {
            var sidebarWidth = document.getElementById("left-sidebar").offsetWidth;
            document.getElementById("map-actions-section").style.left = this.isSidebarOpen ? sidebarWidth + "px" : "0px";
        }
    };
    return BackOfficeComponent;
}(BaseComponent));
export { BackOfficeComponent };
